/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Title_PropertyInputs */

const cs_templates_use_picker_title_property = /** @type {(inputs: Templates_Use_Picker_Title_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte inzerát`)
};

const en_templates_use_picker_title_property = /** @type {(inputs: Templates_Use_Picker_Title_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a listing`)
};

/**
* | output |
* | --- |
* | "Choose a listing" |
*
* @param {Templates_Use_Picker_Title_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_title_property = /** @type {((inputs?: Templates_Use_Picker_Title_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Title_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_title_property(inputs)
	return cs_templates_use_picker_title_property(inputs)
});